'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./node_modules/markdown-it/index.js
// module id = jgMU
// module chunks = 0 111